// Scroll poller
(function ($) {
  var previousScroll = 0;
  let scrollTimeout = null;

  $(window).scroll(function () {
    if(scrollTimeout) {
      clearTimeout(scrollTimeout);
    }

    scrollTimeout = setTimeout(() => {
      let className = '';
      let currentScroll = $(this).scrollTop();

      if (currentScroll > previousScroll) {
        className = 'scrolled';
      } else {
        className = 'scrolled-up';
      }

      // Scrolling all the way to the top and further (bounce)
      if(currentScroll <= 0) {
        className = 'scrolled-upMost';
      }

      previousScroll = currentScroll;
      $('body').removeClass(['scrolled', 'scrolled-up']).addClass(className);
    }, 50); // Only check scroll pos every 50ms
  });
})(jQuery);